import { Padding } from './types';

const toPaddingArray = (padding: number | number[]) =>
  padding ? (Array.isArray(padding) ? padding : [padding, padding, padding, padding]) : [-1, -1, -1, -1];

const isNotMinusOne = (number: number) => number !== -1;

const findNumber = (number: number[]) => {
  return isNotMinusOne(number[0])
    ? number[0]
    : isNotMinusOne(number[1])
    ? number[1]
    : isNotMinusOne(number[2])
    ? number[2]
    : 0;
};

export const usePadding = (padding: Padding) => {
  const desktop = padding.desktop;
  const tablet = padding.tablet;
  const mobile = padding.mobile;
  const desktopArray = toPaddingArray(desktop ?? [-1, -1, -1, -1]);
  const tabletArray = toPaddingArray(tablet ?? [-1, -1, -1, -1]);
  const mobileArray = toPaddingArray(mobile ?? [-1, -1, -1, -1]);
  
  const paddingMatrix = [
    [mobileArray[0], tabletArray[0], desktopArray[0]],
    [mobileArray[1], tabletArray[1], desktopArray[1]],
    [mobileArray[2], tabletArray[2], desktopArray[2]],
    [mobileArray[3], tabletArray[3], desktopArray[3]],
  ].map(row =>
    row.map((number, index) => findNumber(index === 0 ? row : index === 1 ? [row[1], row[0], row[2]] : row.reverse()))
  );
  return {
    paddingTop: paddingMatrix[0],
    paddingRight: paddingMatrix[1],
    paddingBottom: paddingMatrix[2],
    paddingLeft: paddingMatrix[3],
  };

};
